import { render } from "./ClusterAdd.vue?vue&type=template&id=16b9a0ba&scoped=true"
import script from "./ClusterAdd.vue?vue&type=script&lang=js"
export * from "./ClusterAdd.vue?vue&type=script&lang=js"

import "./ClusterAdd.vue?vue&type=style&index=0&id=16b9a0ba&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b9a0ba"]])

export default __exports__